import { Drawer } from "antd";
import React from "react";
import SideNav from "./SideNav";

interface RoundsDrawerProps {
  isOpen: boolean;
  handleDrawerClose: () => void;
}

const RoundsDrawer: React.FC<RoundsDrawerProps> = ({
  handleDrawerClose,
  isOpen,
}) => {
  return (
    <Drawer
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontWeight: "bold" }}>Rounds</div>
          <span
            onClick={handleDrawerClose}
            style={{
              fontSize: "16px",
              color: "#000",
              cursor: "pointer",
            }}
          >
            &times;
          </span>
        </div>
      }
      placement="right"
      onClose={handleDrawerClose}
      open={isOpen}
      width="60%"
      maskClosable={false}
      closeIcon={false}
    >
      <SideNav />
    </Drawer>
  );
};

export default RoundsDrawer;
